import { buildImageSource, buildImageSourceSet, getBaseImageUrl } from '../buildImageSource';
import { getMdsUrl, type MDSAliases } from './getMdsUrl';

const GRID_NAMESPACE = 'grid';

export function resolveCollectionImageSrc(
    media: Inspire.Image[],
    imageAlias?: MDSAliases,
): { src?: string; srcSet?: string } {
    if (imageAlias) {
        const baseUrl = getBaseImageUrl(media);

        return {
            src: baseUrl ? getMdsUrl(baseUrl, imageAlias) : undefined,
        };
    }

    return {
        src: buildImageSource(media, GRID_NAMESPACE),
        srcSet: buildImageSourceSet(media, GRID_NAMESPACE),
    };
}

export function resolveCollectionVideoSrc(firstFrameUrl: string, imageAlias?: MDSAliases): string {
    return imageAlias ? getMdsUrl(firstFrameUrl, imageAlias) : firstFrameUrl;
}
